import { useQuery } from '@tanstack/react-query';
import { proposalConfigurationApi } from '@/api/commercial/proposal-configurations';

export function useProposalConfigurations(proposalId?: string) {
  return useQuery({
    queryKey: ['proposal-configurations', proposalId],
    queryFn: () => proposalConfigurationApi.getConfigurations(proposalId!),
    enabled: !!proposalId,
  });
}
